<template>
    <div id="dojo-report">
        <div class="print-content dojo-print">
            <div v-if="formattedLines"
                 class="report-data">
                <a class="btn btn-lg btn-default right no-print"
                   @click="$emit('print-report')">
                    <i class="fa-regular fa-print"></i>
                    Print Report
                </a>
                <div v-html="formattedLines"></div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'DojoReport',

    props: {
        lines: {
            type: Array,
            default: null,
        },
    },

    emits: [
        'print-report',
    ],

    computed: {
        formattedLines() {
            let formattedLines = [];
            this.lines.forEach((line) => {
                let str = null;
                switch (line.type) {
                    case 'LINE_SEPARATOR_DOUBLE':
                        str = '<hr />';
                        break;
                    default:
                        if (line.format.length === 0) {
                            str = '<div>' + line.value + '</div>';
                        } else {
                            let classes = line.format.join(' ').toLowerCase();
                            str = '<div class="' + classes + '">' + line.value + '</div>';
                        }
                }
                formattedLines.push(str);
            });
            return formattedLines.join('\r\n');
        },
    },
};
</script>

<style lang="less">
@import "../../../../../less/variables";

    #dojo-report {
        .btn {
            float: right;
        }
        .report-data {
            margin-top: @gutter-width;
            padding: @gutter-width;
            color: white;
            border-radius: 5px;
            background: @form-group-container-bg-more-trans;
            div {
                white-space: pre;
                font-family: @font-family-monospace;
                .bold {
                    font-weight: bold;
                }
                .double_height {
                    line-height: 1.5em;
                }
                .double_width {
                    font-size: 1.2em;
                }
            }
            hr {
                display: block;
                height: 2px;
                background: white;
                width: 250px;
                border: none;
            }
        }

    }
</style>
